<template>
  <b-modal
    v-model="showModal"
    content-class="fetching-spinner-content"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header
    hide-footer
    hide-header-close

  >
    <div slot="default">
      <div class="loading-message">
        <p> {{$t('uploading_photo')}}</p>
      </div>
      <spinner-loader />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ImageUploadModal',

  components: {
    SpinnerLoader: () => import('@/components/widgets/SpinnerLoader')
  },

  data: () => ({
    showModal: false
  }),

  methods: {
    show() {
      this.showModal = true;
    },

    hide() {
      this.showModal = false;
    }
  }
};

</script>

<style scoped lang="scss">

.fetching-spinner-content {
  background: transparent !important;
  border: none !important;
}
.loading-message {
  position: relative;
  top: -70px;
  color: #FCFCFC;
}

</style>
